var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBenefit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 101,
    viewBox: "0 0 100 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.5 50.3014C97.5 76.5349 76.2335 97.8014 50 97.8014C23.7665 97.8014 2.5 76.5349 2.5 50.3014C2.5 24.0679 23.7665 2.80139 50 2.80139C76.2335 2.80139 97.5 24.0679 97.5 50.3014Z",
    fill: "white",
    stroke: "#23395D",
    strokeWidth: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9801 43.8715C52.3846 43.8715 55.1444 40.8464 55.1444 37.1148C55.1444 33.3831 52.3846 30.358 48.9801 30.358C45.5756 30.358 42.8157 33.3831 42.8157 37.1148C42.8157 40.8464 45.5756 43.8715 48.9801 43.8715Z",
    fill: "#FF6B00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7419 50.9771H48.3251H54.8387V93.9369H42.7419V50.9771Z",
    fill: "#23395D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefit);
export default __webpack_public_path__ + "static/media/benefit.ec72b56ef5965cf43e621ba2eb8182ce.svg";
export { ForwardRef as ReactComponent };